import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import config, { currentEnvironment } from 'services/config'
import { isExpectedError } from 'utils/sentryReporter'

function initSentry() {
  if (currentEnvironment === 'Production') {
    Sentry.init({
      dsn: config.sentryDsn,
      autoSessionTracking: true,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.3,
      release: `dash${process.env.REACT_APP_VERSION}`,
      normalizeDepth: 4,
      environment: `Production`,
      // Drop expected, already-handled errors regardless of where they originate
      // (manual captures, ErrorBoundary, global handlers, tracing).
      beforeSend(event, hint) {
        const originalException = hint?.originalException
        const exceptionValue = event?.exception?.values?.[0]?.value

        if (
          isExpectedError(originalException) ||
          isExpectedError(event?.message) ||
          isExpectedError(exceptionValue)
        ) {
          return null
        }

        return event
      }
    })
  }
}

export default initSentry
